import type { FormBuilderFieldOption } from '@/components/FormBuilder/FormBuilder.model';

export const hasOptionValues = (options: unknown): true | string => {
  if (!Array.isArray(options)) {
    return 'All options must have a value';
  }
  const hasValue = (option: FormBuilderFieldOption) =>
    option.value !== '' && option.value !== null && option.value !== undefined;
  return options.every((opt: FormBuilderFieldOption) => hasValue(opt)) || 'All options must have a value';
};
